import React, { Component } from 'react';
import ValueList from '../../../../containers/components/ValueList';
import Literal from '../../../Literal';

import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../redux';
import TextField from '../../../TextField';

@connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })
class RenderValueListField extends Component {
    onChangeDefault = (_, pos, data) => {
        const { onChange } = this.props;
        let obj;
        if (pos > -1) {
            let valueList = data.get(pos);
            obj = { value: valueList['-id'], description: valueList.descripcion };
        }
        onChange(obj);
    };

    onClear = () => {
        const { onChange } = this.props;

        onChange({ value: -1, description: '' });
    };

    renderDisabled = () => {
        const {
            styles,
            pos,
            width,
            edit,
            value,
            config,
            onChange,
            error,
            onNavigationKeyPressed,
            refCrud,
        } = this.props;
        let realValue = value ? value.description : value;
        return (
            <TextField
                ref={refCrud}
                underlineDisabledStyle={{ borderColor: 'TRANSPARENT' }}
                disabled={!edit || config.readOnly}
                value={realValue}
                hintText={'-'}
                hintStyle={styles.hintStyle}
                inputStyle={{ ...styles.inputStyle, width: width - 20 }}
                underlineStyle={{ borderColor: 'TRANSPARENT' }}
                showClear={false}
                style={{ width: '' }}
            />
        );
    };

    renderValueList = () => {
        const {
            styles,
            pos,
            width,
            edit,
            value,
            config,
            onChange,
            error,
            onNavigationKeyPressed,
            refCrud,
        } = this.props;
        let realValue = value ? value.description : value;
        return (
            <ValueList
                refCrud={refCrud}
                errorText={error}
                disabled={!edit || config.readOnly}
                searchText={realValue}
                fullWidth={true}
                style={{ ...styles.inputStyle, width: width - 20 }}
                inputStyle={{ ...styles.inputStyle, width: width - 20 }}
                hintStyle={styles.hintStyle}
                hintText={edit ? <Literal literal="label_selectone" /> : '-'}
                processData={this.processData}
                table={config.valueListName}
                menuStyle={{ width: 300, overflowY: 'auto' }}
                onSelectItem={this.onChangeDefault}
                onNavigationKeyPressed={onNavigationKeyPressed}
                onClear={this.onClear}
            />
        );
    };

    render() {
        const {
            styles,
            pos,
            width,
            edit,
            value,
            config,
            onChange,
            error,
            onNavigationKeyPressed,
            refCrud,
        } = this.props;
        let realValue = value ? value.description : value;
        return (
            <div style={{ width: width, display: 'inline-block' }}>
                {!edit || config.readOnly ? this.renderDisabled() : this.renderValueList()}
            </div>
        );
    }
}

export default RenderValueListField;
